import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { I18nProvider } from './contexts/I18nContext';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import Legal from './pages/Legal';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Cookies from './pages/legal/Cookies';
import Licenses from './pages/legal/Licenses';
import StudentPortalLayout from './layout/StudentPortalLayout';
import PortalHome from './pages/portal/PortalHome';
import PortalOnboarding from './pages/portal/PortalOnboarding';
import PortalApplication from './pages/portal/PortalApplication';
import PortalUniversities from './pages/portal/PortalUniversities';
import PortalPayments from './pages/portal/PortalPayments';
import PortalDocuments from './pages/portal/PortalDocuments';
import PortalContract from './pages/portal/PortalContract';
import PortalChat from './pages/portal/PortalChat';
import PortalProfile from './pages/portal/PortalProfile';
import PortalHelp from './pages/portal/PortalHelp';
import GermanySteps from './pages/GermanySteps';
import ItalySteps from './pages/ItalySteps';
import LithuaniaSteps from './pages/LithuaniaSteps';
import PortugalSteps from './pages/PortugalSteps';
import Scholarship from './pages/Scholarship';
import ScholarshipAcceptance from './pages/ScholarshipAcceptance';
import ScholarshipEnglish from './pages/ScholarshipEnglish';
import ScholarshipGrantDetails from './pages/ScholarshipGrantDetails';
import PublicContract from './pages/PublicContract';
import SamirContract from './pages/SamirContract';

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <NotificationProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/cookies" element={<Cookies />} />
            <Route path="/legal/licenses" element={<Licenses />} />
            <Route path="/scholarship" element={<Scholarship />} />
            <Route path="/scholarship/details" element={<ScholarshipGrantDetails />} />
            <Route path="/scholarship/english/:token" element={<ScholarshipEnglish />} />
            <Route path="/scholarship/acceptance/:token" element={<ScholarshipAcceptance />} />
            <Route path="/contract" element={<PublicContract />} />
            <Route path="/samir-contract" element={<SamirContract />} />
            {/* The new student portal is the only active application flow. */}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <StudentPortalLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<PortalHome />} />
              <Route path="onboarding" element={<PortalOnboarding />} />
              <Route path="application" element={<PortalApplication />} />
              <Route path="universities" element={<PortalUniversities />} />
              <Route path="documents" element={<PortalDocuments />} />
              <Route path="payments" element={<PortalPayments />} />
              <Route path="contract" element={<PortalContract />} />
              <Route path="chat" element={<PortalChat />} />
              <Route path="profile" element={<PortalProfile />} />
              <Route path="help" element={<PortalHelp />} />
              <Route path="destination" element={<Navigate to="/app" replace />} />
              <Route path="italy" element={<Navigate to="/app" replace />} />
            </Route>

            {/* Retired URLs never render their legacy pages. */}
            <Route path="/dashboard/profile" element={<Navigate to="/app/profile" replace />} />
            <Route path="/profile-setup" element={<Navigate to="/app/profile" replace />} />
            <Route path="/account/delete" element={<Navigate to="/app/profile" replace />} />
            <Route path="/dashboard/*" element={<Navigate to="/app" replace />} />
            <Route path="/applications/*" element={<Navigate to="/app/application" replace />} />
            <Route path="/countries/*" element={<Navigate to="/app" replace />} />
            <Route path="/universities/*" element={<Navigate to="/app/universities" replace />} />
            <Route path="/programs/*" element={<Navigate to="/app" replace />} />
            <Route path="/scholarships/*" element={<Navigate to="/app" replace />} />
            <Route path="/germany-steps" element={<GermanySteps />} />
            <Route path="/italy-steps" element={<ItalySteps />} />
            <Route path="/lithuania-steps" element={<LithuaniaSteps />} />
            <Route path="/portugal-steps" element={<PortugalSteps />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </NotificationProvider>
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
